import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import emailjs from "emailjs-com";

const rotatingWords = ["Veterinary Medicine", "Science", "AI", "Medicine", "More Things"];

function App() {
  const [index, setIndex] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef();

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % rotatingWords.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  const handleClickOutside = (e) => {
    if (formRef.current && !formRef.current.contains(e.target)) {
      setShowForm(false);
    }
  };

  useEffect(() => {
    if (showForm) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showForm]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    const name = form.user_name.value;
    const email = form.user_email.value;
    const interestedIdea = form.interested_idea.checked;
    const joinConcept = form.join_concept.checked;
    const advisorInvestor = form.advisor_investor.checked;

    const formData = {
      user_name: name,
      user_email: email,
      interested_idea: interestedIdea ? "✔ I have an idea or concept" : "",
      join_concept: joinConcept ? "✔ I want to join the buildout of a concept" : "",
      advisor_investor: advisorInvestor ? "✔ I want to join as an advisor or investor" : "",
    };

    emailjs
      .send(
        "service_3psl0rp",      // 🔁 Replace with your EmailJS service ID
        "template_cqafawb",     // 🔁 Replace with your EmailJS template ID
        formData,
        "GzuOmwtteJgGj8sHz"       // 🔁 Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log("Email successfully sent!", result.text);
          setShowForm(false);
        },
        (error) => {
          console.error("Failed to send email:", error);
        }
      );
  };

  return (
    <main className="min-h-screen bg-[#1e52df] text-white font-sans">
      <section className="h-screen flex flex-col justify-between">
        <header className="flex flex-col md:flex-row items-center justify-between px-6 py-6 gap-4 md:gap-0">
          <h1 className="text-2xl font-bold tracking-wide">Blue Dandelion</h1>
        </header>

        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="flex-1 flex flex-col justify-center items-center px-4 text-center"
        >
          {!showForm ? (
            <>
              <h2 className="text-3xl sm:text-4xl md:text-6xl font-semibold leading-tight max-w-4xl">
                Reimagining the Future of{" "}
                <span className="inline-block text-[#d41409] min-w-[7ch]">
                  <AnimatePresence mode="wait">
                    <motion.span
                      key={rotatingWords[index]}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.5 }}
                    >
                      {rotatingWords[index]}
                    </motion.span>
                  </AnimatePresence>
                </span>
              </h2>
              <p className="text-base sm:text-lg mt-6 max-w-md text-gray-200 px-2">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae orci eu lorem volutpat faucibus.
              </p>
              <button
                className="mt-8 bg-[#ffbf1e] hover:bg-[#f9b300] text-white px-6 py-3 text-base sm:text-lg rounded-full"
                onClick={() => setShowForm(true)}
              >
                Learn More
              </button>
            </>
          ) : (
            <motion.div
              ref={formRef}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="w-full max-w-lg text-left bg-white text-black p-6 rounded-lg shadow-lg relative"
            >
              <h3 className="text-2xl font-semibold mb-4">Join The Community</h3>
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div>
                  <label className="block mb-1 text-sm font-medium">Name</label>
                  <input name="user_name" type="text" className="w-full px-4 py-2 border rounded" placeholder="Your name" />
                </div>
                <div>
                  <label className="block mb-1 text-sm font-medium">Email</label>
                  <input name="user_email" type="email" className="w-full px-4 py-2 border rounded" placeholder="you@example.com" />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium">Check all that apply</label>
                  <div className="space-y-2 pl-1">
                    <label className="flex items-center space-x-2">
                      <input type="checkbox" name="interested_idea" className="form-checkbox accent-blue-600" />
                      <span>I have an idea or concept</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input type="checkbox" name="join_concept" className="form-checkbox accent-blue-600" />
                      <span>I want to join the buildout of a concept</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input type="checkbox" name="advisor_investor" className="form-checkbox accent-blue-600" />
                      <span>I want to join as an advisor or investor</span>
                    </label>
                  </div>
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="bg-[#ffbf1e] hover:bg-[#f9b300] text-white px-4 py-2 rounded"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </motion.div>
          )}
        </motion.section>

        <footer className="text-center text-sm py-6 text-gray-200">
          &copy; {new Date().getFullYear()} Blue Dandelion. All rights reserved.
        </footer>
      </section>
    </main>
  );
}

export default App;
